interface Props {
  onHelp?: () => void;
}

export default function GettingStarted({ onHelp }: Props): JSX.Element {
  return (
    <div style={{
      marginBottom: "2rem",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      backgroundColor: "#fff",
      padding: "1rem 1.25rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "1rem",
    }}>
      <p style={{ margin: 0, fontSize: "0.9rem", color: "#444" }}>
        The CAI marketplace is <strong>already installed</strong> in Claude Desktop. Just open
        <strong> Customize → Browse Plugins → Plugins Directory</strong> and find plug-ins under your
        organization&rsquo;s tab — no file downloads in Claude Desktop. Individual skills aren&rsquo;t listed
        in the Plugins Directory, so download those from their detail page and add them manually. Claude
        Code and GitHub Copilot install from the same marketplace via CLI. See the setup guide for details.
      </p>
      {onHelp && (
        <button
          type="button"
          onClick={onHelp}
          style={{
            flexShrink: 0,
            padding: "0.4rem 0.85rem",
            fontSize: "0.85rem",
            backgroundColor: "transparent",
            color: "#0078d4",
            border: "1px solid #0078d4",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Setup guide
        </button>
      )}
    </div>
  );
}
